export const STATUS = { IDLE: 0, ERROR: 1, ACCEPTED: 2, REJECTED: 3 };

export const ACCEPTED_STEP_CONTENT = {
  LISTER: {
    SUCCESS_CTA: "booking_request.lister.success.cta",
    SUCCESS_DESCRIPTION: "booking_request.lister.success.description",
    SUCCESS_TITLE: "booking_request.lister.success.title",
  },
};
